module.exports = __WEBPACK_EXTERNAL_MODULE__journeyapps_wa_sqlite__;